import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAlarmListResponse } from '@/api/type/commonTypes';

export interface ToastItem extends GetAlarmListResponse {
  toastId: string; // 토스트 자체의 고유 key
}

interface ToastState {
  items: ToastItem[]; // items[0] = 가장 최근(맨 위), 마지막 = 가장 오래된(맨 아래)
}

const initialState: ToastState = {
  items: [],
};

const MAX_TOAST_COUNT = 4;

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    addToast: (state, action: PayloadAction<GetAlarmListResponse>) => {
      const newItem: ToastItem = {
        ...action.payload,
        toastId: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      };
      state.items.unshift(newItem);
      if (state.items.length > MAX_TOAST_COUNT) {
        state.items.pop(); // 가장 오래된 항목 제거
      }
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(
        (item) => item.toastId !== action.payload
      );
    },
  },
});

export const toast = toastSlice.actions;
export default toastSlice.reducer;
